import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { auth, getAccessToken } from '../../firebase';

const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const getTokens = async () => {
    try {
        const url = `${BASE_URL}/tokeninfo/usdStableCoins`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status == 201) {
            return {
                status: response.status,
                data: response?.data,
            };
        }
    } catch (error) {
        return error;
    }
};

export const getChains = async () => {
    try {
        const url = `${BASE_URL}/blockchain`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status == 201) {
            return {
                status: response.status,
                data: response?.data,
            };
        }
    } catch (error) {
        return error;
    }
};
export const uploaderApi = async (payload) => {
    try {
        const url = `${BASE_URL}/microtaskdata/upload`;

        const accessGoogle = await auth.currentUser.getIdToken(true);
        const response = await axios.post(url, payload, {
            headers: {
                Authorization: `Bearer ${accessGoogle}`,
            },
        });

        return response.data;
    } catch (error) {
        console.log(error);
    }
};

export const getTokensForBudget = async () => {
    const url = `${BASE_URL}/tokeninfo`;
    try {
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getSuperpowers = async () => {
    const url = `${BASE_URL}/superpower`;
    try {
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getImpactPoints = async ({ bountyType, symbol, amount }, isFiatReward) => {
    // const url = `${BASE_URL}/bounty/impactPoints?bountyType=${bountyType}&rewardToken=${symbol}&maxRewardAmount=${amount}&isRewardInFiat=${isFiatReward}`;
    const url = `${BASE_URL}/bounty/impactPoints?bountyType=${bountyType}&rewardToken=${symbol}&maxRewardAmount=${amount}`;
    try {
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getICImageOnBountyCreationScreen = async (
    { coresArray, briefMessage, sdgsArray, tokenSymbol, amount, backerName },
    withReward, isFiatReward
) => {
    // const url = `${BASE_URL}/impactCertificate/preview?cores=${coresArray.join(
    //     '~'
    // )}&impactBrief=${briefMessage}&SDGs=${sdgsArray.join('~').replace(/&/g, '%26')}${
    //     backerName ? `&backer=${backerName}` : ''
    // }${withReward ? `&rewardTokenSymbol=${tokenSymbol}&rewardTokenAmount=${amount?.toString()}` : ''}&isRewardInFiat=${isFiatReward}`;
    const url = `${BASE_URL}/impactCertificate/preview?cores=${coresArray.join(
        '~'
    )}&impactBrief=${briefMessage}&SDGs=${sdgsArray.join('~').replace(/&/g, '%26')}${backerName ? `&backer=${backerName}` : ''
        }${withReward ? `&rewardTokenSymbol=${tokenSymbol}&rewardTokenAmount=${amount?.toString()}` : ''}`;
    // backer=name

    try {
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response;
        }
    } catch (error) {
        return error;
    }
};

export const getTokenInfo = async (sym) => {
    const url = `${BASE_URL}/tokeninfo/getDetails?symbol=${sym}`;
    try {
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};
